import React from 'react';
import PropTypes from 'prop-types';

class ErrorMessage extends React.Component {
  render() {
    return (
      <div className={`alert ${this.props.theme} text-left`}>
        <p>
          <strong>Error {this.props.error.code}:&nbsp;</strong>
          <small>({this.props.error.origin})</small>
        </p>
        <p>{this.props.error.message}</p>
      </div>
    );
  }
}

/**
  *  this.props.error expects { code, origin, message }
  *  Code is the error's status code
  *  Origin is the route or process that induced the error
  *  Message is the message for the user to read
*/
ErrorMessage.propTypes = {
  error: PropTypes.object,
  theme: PropTypes.string
};
ErrorMessage.defaultProps = {
  theme: 'alert-danger'
};

export default ErrorMessage;
